import script from "./template.vue?vue&type=script&setup=true&lang=ts"
export * from "./template.vue?vue&type=script&setup=true&lang=ts"

import "./template.vue?vue&type=style&index=0&id=2213e2a7&lang=css"

const __exports__ = script;

export default __exports__